<template>
  <article class="lead-communication-message" :class="directionClass">
    <div class="lead-communication-message__bubble">
      <strong v-if="communication.subject && !hideSubject">{{ communication.subject }}</strong>
      <p v-if="communication.report">{{ communication.report }}</p>
      <p v-else class="lead-communication-message__empty">No message text</p>
      <footer>
        <span v-if="phoneDirection">{{ phoneDirection }}</span>
        <span v-if="communication.stage" :style="{ color: communication.stage.color }">
          {{ communication.stage.name }}
        </span>
        <span v-if="communication.source">via {{ communication.source.name }}</span>
        <LeadCommunicationRating
          :rating="communication.first_reply_rating"
          :communication-id="communication.id"
        />
        <LeadCommunicationDeliveryStatus
          :status="communication.delivery_status"
          :communication-methods="communication.methods"
        />
        <time
          v-tooltip="{ content: formatExactDate(communication.date), placement: 'top', offset: 8 }"
        >
          {{ formatRelativeDate(communication.date) }}
        </time>
        <LeadFlowCommunicationRowMenu
          v-if="isManual"
          :pending="pending"
          @edit="$emit('edit', communication)"
          @delete="$emit('delete', communication.id)"
        />
      </footer>
    </div>
  </article>
</template>

<script>
import LeadCommunicationDeliveryStatus from '@/views/crm/task-tracker/LeadCommunicationDeliveryStatus.vue'
import LeadCommunicationRating from '@/views/crm/task-tracker/LeadCommunicationRating.vue'
import LeadFlowCommunicationRowMenu from '@/views/crm/task-tracker/LeadFlowCommunicationRowMenu.vue'
import { formatExactDate, formatRelativeDate } from '@/views/crm/task-tracker/leadFlowDate'

export default {
  name: 'LeadCommunicationMessage',
  components: {
    LeadCommunicationDeliveryStatus,
    LeadCommunicationRating,
    LeadFlowCommunicationRowMenu
  },
  props: {
    communication: {
      type: Object,
      required: true
    },
    pending: {
      type: Boolean,
      default: false
    },
    hideSubject: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    directionClass() {
      const code = this.communication.direction && this.communication.direction.code
      return code ? `lead-communication-message--${code}` : ''
    },
    isManual() {
      return Boolean(this.communication.source && this.communication.source.code === 'manual')
    },
    phoneDirection() {
      const isPhone = (this.communication.methods || []).some(method => {
        const value = String(method.code || method.id || method.name || '').toLowerCase()
        return value.includes('phone') || value.includes('call')
      })
      if (!isPhone) return ''
      const code = this.communication.direction && this.communication.direction.code
      if (code === 'inbound') return 'Incoming'
      if (code === 'outbound') return 'Outgoing'
      return ''
    }
  },
  methods: {
    formatExactDate,
    formatRelativeDate
  }
}
</script>

<style scoped>
.lead-communication-message {
  display: flex;
  justify-content: flex-start;
}

.lead-communication-message--outbound {
  justify-content: flex-end;
}

.lead-communication-message__bubble {
  max-width: 86%;
  min-width: 170px;
  padding: 9px 10px;
  border: 1px solid #d9e4d4;
  border-radius: 4px 10px 10px;
  background: #f1f8ec;
}

.lead-communication-message--outbound .lead-communication-message__bubble {
  border-color: #d7e1e7;
  border-radius: 10px 4px 10px 10px;
  background: #eef5f8;
}

.lead-communication-message:not(.lead-communication-message--inbound):not(.lead-communication-message--outbound) .lead-communication-message__bubble {
  border-color: #dfe3df;
  border-radius: 8px;
  background: #f5f6f3;
}

.lead-communication-message__bubble > strong {
  display: block;
  margin-bottom: 5px;
  color: #344749;
  font-size: 10px;
}

.lead-communication-message__bubble > p {
  margin: 0;
  color: #435557;
  font-size: 10px;
  line-height: 15px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.lead-communication-message__empty {
  color: #909b99 !important;
  font-style: italic;
}

.lead-communication-message footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
  margin-top: 7px;
  color: #84908e;
  font-size: 8px;
}

.lead-communication-message footer time {
  white-space: nowrap;
}
</style>
